import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { reviewDesk } from '@/design-system';
import type { Language } from '../../../i18n';
import type { LanguageOption } from '../modals/LanguageSelectModal';
import { profileWebStyles } from '../profileStyles';
import type { Translate } from '../profileTypes';

interface LanguagePreferencesPanelProps {
  language: Language;
  availableLanguages: LanguageOption[];
  onOpenLanguageSelect: () => void;
  /** Stacked in a single column (phone/tablet). */
  isCompact: boolean;
  t: Translate;
}

export function LanguagePreferencesPanel({
  language,
  availableLanguages,
  onOpenLanguageSelect,
  isCompact,
  t,
}: LanguagePreferencesPanelProps) {
  return (
    <View
      testID="profile_language_panel"
      style={[profileWebStyles.panel, isCompact && profileWebStyles.panelStacked]}
    >
      <Text style={profileWebStyles.panelTitle}>{t('profile.webLanguagePreferences')}</Text>
      <TouchableOpacity
        testID="profile_language_select"
        style={profileWebStyles.selectRow}
        onPress={onOpenLanguageSelect}
        accessibilityRole="button"
      >
        <View style={profileWebStyles.selectLeft}>
          <MaterialIcons name="language" size={22} color={reviewDesk.accent} />
          <View>
            <Text style={profileWebStyles.selectTitle}>
              {availableLanguages.find((lang) => lang.code === language)?.nativeName || language.toUpperCase()}
            </Text>
            <Text style={profileWebStyles.selectMeta}>{t('profile.webLanguageMeta')}</Text>
          </View>
        </View>
        <MaterialIcons name="expand-more" size={22} color={reviewDesk.inkSoft} />
      </TouchableOpacity>
    </View>
  );
}
